
import { initialiseInstanceComponents } from '../../shared/instanceComponentInitialiser';
import { AttributeEnums } from '../../shared/utilities/enums/attributeEnums';
import { HelperUtils } from '../../shared/utilities/helperUtils';
import { Carousel } from './carousel';
import { CarouselInfiniteLoad } from './carouselInfiniteLoad';

export function initialiseCarouselInfiniteLoad() {
    initialiseInstanceComponents<CarouselInfiniteLoad>(CarouselInfiniteLoad, HelperUtils.addDataAttributeTags(AttributeEnums.CarouselInfiniteLoad.CarouselInfiniteLoad), carouselInfiniteLoadFactory);
}

function carouselInfiniteLoadFactory(currentElement: Element): void {
    let getCellsOnInitialise: boolean = true;
    try {
        getCellsOnInitialise = (currentElement.getAttribute(AttributeEnums.CarouselInfiniteLoad.GetCellsOnInitialise).toLowerCase() !== "false");
    } catch
    {
        getCellsOnInitialise = true;
    }

    let newCarouselInfiniteLoad = new CarouselInfiniteLoad(currentElement, currentElement.getAttribute(AttributeEnums.CarouselInfiniteLoad.Url), getCellsOnInitialise);
    (<any>window)[currentElement.getAttribute(AttributeEnums.CarouselInfiniteLoad.CarouselInfiniteLoad) + 'CarouselInfiniteLoad'] = newCarouselInfiniteLoad;
}